// Кнопка «←» навбара (Figma ArrowLeft 24): лента новостей — без подложки (_Left 40×40), статья — круглая 44 на
// --ground (Button Group 1). Системная «Назад» Telegram остаётся; в магазинной сборке своей системной нет —
// эта кнопка там единственная. Шаг по истории тот же, что у системной (navigate(-1)).
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n/i18n';
import styles from './NavBackButton.module.css';

export function NavBackButton({ round = false }: { round?: boolean }) {
  const navigate = useNavigate();
  return (
    <button type="button" className={`${styles.back} ${round ? styles.round : ''}`} aria-label={t('tg_back')}
      onClick={() => navigate(-1)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.25 12H3.75M10.5 5.25 3.75 12l6.75 6.75" />
      </svg>
    </button>
  );
}
